var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-button',{attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading,"show-loading":_vm.loading},nativeOn:{"click":function($event){return _vm.func($event)}}},[_vm._t("default",null,{"loading":_vm.loading})],2)}
var staticRenderFns = []

export { render, staticRenderFns }